// extracted by mini-css-extract-plugin
module.exports = {"cursor":"ReloveIconComment_cursor__3RkGA","root":"ReloveIconComment_root__2V6Op"};